<template>
  <div class="main">
    <Header
      :show="true"
      title="编辑字典"
      left="prepage"
      :click-left="handleClickLeft"
    />
    <div style="padding-bottom: 8vh">
      <van-form
        ref="create"
        @submit="submit"
      >
        <van-field
          name="type"
          label="字典名称"
          placeholder="请输入"
          readonly
        >
          <template #input>
            {{ listQuery.typeName }}
          </template>
        </van-field>
        <van-field
          v-model.trim="listQuery.label"
          label="数据标签"
          disabled
          required
          placeholder="请输入"
          :rules="[{ required: true, message: '请输入数据标签名' }]"
        />
        <van-field
          v-model.trim="listQuery.code"
          label="数据编码"
          placeholder="请输入"
          required
          disabled
          :rules="[{ required: true, message: '请输入数据编码' }]"
        />
        <van-field
          v-if="listQuery.code === 'checkType'"
          label="数据值"
          name="value"
          required
        >
          <template #input>
            <van-switch
              v-model="listQuery.value"
              size="20px"
              active-value="1"
              inactive-value="0"
            />
            <span
              style="font-size: 14px; color: #ccc; margin-left: 12px"
            >勾选即启用</span>
          </template>
        </van-field>
        <van-field
          v-else-if="gcpzKeySwitch.includes(listQuery.code)"
          label="数据值"
          name="value"
          required
        >
          <template #input>
            <van-switch
              v-model="listQuery.value"
              size="20px"
              active-value="开启"
              inactive-value="关闭"
            />
            <span
              style="font-size: 14px; color: #ccc; margin-left: 12px"
            >勾选即开启</span>
          </template>
        </van-field>
        <van-field
          v-else-if="gcpzKeyApply.includes(listQuery.code)"
          label="数据值"
          name="value"
          required
        >
          <template #input>
            <van-switch
              v-model="listQuery.value"
              size="20px"
              active-value="自动审核"
              inactive-value="手动审核"
            />
            <span
              style="font-size: 14px; color: #ccc; margin-left: 12px"
            >勾选即自动审核</span>
          </template>
        </van-field>
        <van-field
          v-else
          v-model.trim="listQuery.value"
          label="数据值"
          placeholder="请输入"
          required
          :rules="[{ required: true, message: '请输入数据值' }]"
        />
        <van-field
          v-model.trim="listQuery.description"
          label="备注"
          placeholder="请输入"
        />
        <div
          v-if="checkPermission([402])"
          style="margin: 0.6rem 1rem"
        >
          <van-button
            round
            block
            type="info"
            native-type="submit"
          >
            确定
          </van-button>
        </div>
      </van-form>
    </div>
    <Footer value="service" />
  </div>
</template>

<script>
import { Dialog } from "vant";
import { showPhoneAlarm } from "@/global/function.js";
import checkPermission from "@/utils/permission";
import Header from "@/views/components/header/index.vue";
import Footer from "@/views/components/footer/index.vue";

import { updateData } from "@/api/dict.js";

export default {
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      loading: false,
      listQuery: {
        name: "",
        type: "",
      },
      gcpzKeySwitch: [
        "overweightAllowed",
        "stoneMoistureDetection",
        "powderDetectionSampling",
        "fillingIgnore",
        "sandMoistureDetection",
        "workspaceAuditWay",
        "truckReserveAudit",
      ],
      gcpzKeyApply: ["productAreaAuditWay"],
    };
  },
  created() {
    this.listQuery = this.$route.query;
  },
  methods: {
    checkPermission,
    handleClickLeft() {
      this.$router.go(-1);
    },
    async submit() {
      const _this = this;
      const { code, description, label, value, typeId, id } = this.listQuery;
      const payload = {
        id,
        code,
        label,
        value,
        description,
        typeId,
      };

      Dialog.confirm({
        title: "确认编辑字典？",
      })
        .then(() => {
          _this.loading = true;

          updateData(payload)
            .then((response) => {
              const { data } = response;
              if (
                showPhoneAlarm(
                  true,
                  "toast",
                  null,
                  2000,
                  data.code,
                  "编辑字典",
                  data.message
                )
              ) {
                _this.$router.go(-1);
              }
            })
            .finally(() => {
              _this.loading = false;
            });
        })
        .catch(() => {
          showPhoneAlarm(
            true,
            "toast",
            "success",
            2000,
            200,
            "编辑字典",
            "取消"
          );
        });
    },
  },
};
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  font-size: 2vw;
  background-color: #ffffff; //#F8F8F8;
  overflow-x: hidden;
  // overflow-y:hidden;
  overflow-y: auto;
  // display: flex;
  // justify-content: center;
  // align-items: center;
}
</style>
